import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObj: {
    SheetNo: 0,
    Loc: "",
    LocName: "",
    Date: new Date(),
    ReferenceNo: "",
    A_DocStat: "ENTER",
    BinCd: "",
    BinName: ""
  },
  SummaryObj: {
    loc: "",
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
  },
};

const SliceCyclecount = createSlice({
  name: "SliceCyclecount",
  initialState: { value: initialState },

  reducers: {
    Set_SliceCyclecount_HeadObj: (state, action) => {
      state.value.HeadObj = action.payload;
    },
    Set_SliceCyclecount_HeadObj_Init: (state, action) => {
      state.value.HeadObj = initialState.HeadObj;
    },

    Set_SliceCyclecount_SummaryObj: (state, action) => {
      state.value.SummaryObj = action.payload;
    },
    SliceCyclecount_Init: (state) => {
      state.value = initialState;
    },

    Set_SliceCyclecount_HeadObj_New_Set: (state, action) => {
      state.value.HeadObj.SheetNo = action.payload.SheetNo;
      state.value.HeadObj.Loc = action.payload.Loc;
      state.value.HeadObj.Date = action.payload.Date;
      state.value.HeadObj.ReferenceNo = action.payload.ReferenceNo;
    },
    Set_SliceCyclecount_HeadObject_A_DocStat: (state, action) => {
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
    Set_SliceCyclecount_HeadObject_SheetNo_A_DocStat: (
      state,
      action
    ) => {
      state.value.HeadObj.SheetNo = action.payload.SheetNo;
      state.value.HeadObj.A_DocStat = action.payload.A_DocStat;
    },
  },
});

export const {
  Set_SliceCyclecount_HeadObj,
  Set_SliceCyclecount_SummaryObj,
  Set_SliceCyclecount_HeadObject_A_DocStat,
  Set_SliceCyclecount_HeadObject_SheetNo_A_DocStat,
  SliceCyclecount_Init,
  Set_SliceCyclecount_HeadObj_Init,
  Set_SliceCyclecount_HeadObj_New_Set,
} = SliceCyclecount.actions;
export default SliceCyclecount.reducer;
